import { Card, CardBody, Col } from "reactstrap";
import { H3, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import { socialWidgetsData } from "../../../../Data/Widgets/GeneralWidgetsData";
import ReactApexChart from "react-apexcharts";

const SocialIcon = () => {
  return (
    <>
      {socialWidgetsData.map((data,i)=>(
        <Col xl="3" sm="6" key={i}>
          <Card className="social-widget">
            <CardBody>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <div className="social-icons">
                    <Image src={dynamicImage(`dashboard/social/${data.img}`)} alt={data.alt} />
                  </div>
                  <span>{data.title}</span>
                </div>
                <span className="font-success f-12 d-xxl-block d-xl-none">
                  {data.count}
                </span>
              </div>
              <div className="social-content">
                <div>
                  <H3 className="mb-1">{data.followers}</H3>
                  <span className="f-light">{data.content}</span>
                </div>
                <div className="social-chart">
                  <ReactApexChart options={data.chart} series={data.chart.series} type="radialBar" height={130} />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default SocialIcon;
